import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetInfoPrestacionCUME = {
  status: number | null;
  statusText: string | null;
};

const useGetInfoPrestacionCUME = () => {
  const [loadingGetInfoPrestacionCUME, setLoadingGetInfoPrestacionCUME] = useState(false);
  const [successGetInfoPrestacionCUME, setSuccessGetInfoPrestacionCUME] = useState(false);
  const [errorGetInfoPrestacionCUME, setErrorGetInfoPrestacionCUME] = useState<any>(null);
  const [dataGetInfoPrestacionCUME, setDataGetInfoPrestacionCUME] = useState<any>(null);

  const [statusGetInfoPrestacionCUME, setStatusGetInfoPrestacionCUME] =
    useState<StatusGetInfoPrestacionCUME>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getInfoPrestacionCUME = async (
    userId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetInfoPrestacionCUME(true);
    setSuccessGetInfoPrestacionCUME(false);
    setErrorGetInfoPrestacionCUME(null);

    try {
      const res = await apiRecord.getInfoPrestacionEconomicaCUME(userId);

      setStatusGetInfoPrestacionCUME({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessGetInfoPrestacionCUME(true);
      setDataGetInfoPrestacionCUME(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetInfoPrestacionCUME({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetInfoPrestacionCUME(err);
      console.error("Error en getInfoPrestacionCUME:", err);

      throw err;

    } finally {
      setLoadingGetInfoPrestacionCUME(false);
    }
  };

  return {
    getInfoPrestacionCUME,
    loadingGetInfoPrestacionCUME,
    successGetInfoPrestacionCUME,
    errorGetInfoPrestacionCUME,
    dataGetInfoPrestacionCUME,
    statusGetInfoPrestacionCUME
  };
};

export default useGetInfoPrestacionCUME;
